import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { adminApi } from '../api'
import { toastUtil } from '../../utils/toast'

const AdminLogin: React.FC = () => {
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    const adminToken = localStorage.getItem('admin_token')
    if (adminToken) {
      navigate('/admin/users')
    }
  }, [navigate])

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()

    if (!username || !password) {
      toastUtil.error('아이디와 비밀번호를 입력해주세요')
      return
    }

    setIsLoading(true)
    try {
      await adminApi.login({ username, password })
      navigate('/admin/users')
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message ||
        error.response?.data?.errors?.username?.[0] ||
        '로그인 중 오류가 발생했습니다.'
      toastUtil.error(errorMessage)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="min-h-screen bg-backgroundColorBg2 flex items-center justify-center p-24px">
      <div className="w-full max-w-400px bg-white rounded-16px shadow-lg p-40px">
        <div className="flex flex-col items-center mb-32px">
          <h1 className="text-style-title1 text-brown-80%-main mb-8px">TASTEE</h1>
          <p className="text-style-body2 text-textColorText2">관리자 로그인</p>
        </div>

        <form onSubmit={handleLogin} className="flex flex-col gap-20px">
          <div>
            <label className="block text-style-labelM text-textColorText2 mb-8px">
              아이디
            </label>
            <input
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="아이디를 입력해주세요"
              className={`
                w-full
                py-12px
                px-16px
                border
                border-brandPrimary-20%
                rounded-8px
                text-style-body1
                text-textColorText2
                bg-transparent
                focus:outline-none
                focus:border-brandPrimary
                placeholder:text-textColorText2
              `}
              disabled={isLoading}
            />
          </div>

          <div>
            <label className="block text-style-labelM text-textColorText2 mb-8px">
              비밀번호
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="비밀번호를 입력해주세요"
              className={`
                w-full
                py-12px
                px-16px
                border
                border-brandPrimary-20%
                rounded-8px
                text-style-body1
                text-textColorText2
                bg-transparent
                focus:outline-none
                focus:border-brandPrimary
                placeholder:text-textColorText2
              `}
              disabled={isLoading}
            />
          </div>

          <button
            type="submit"
            disabled={isLoading || !username || !password}
            className={`
              w-full
              py-14px
              rounded-8px
              text-style-button1
              text-white
              border-none
              cursor-pointer
              transition-all
              active:scale-[0.98]
              ${
                isLoading || !username || !password
                  ? 'bg-textColorText3 cursor-not-allowed'
                  : 'bg-4B3621-80% hover:bg-4B3621-80%-70%'
              }
            `}
          >
            {isLoading ? '로그인 중...' : '로그인'}
          </button>
        </form>

        <div className="mt-32px pt-32px border-t border-brandPrimary-10% flex items-center justify-center gap-16px">
          <button
            type="button"
            onClick={() => navigate('/terms')}
            className="text-style-body2 text-textColorText2 hover:text-brown-80%-main transition-colors"
          >
            이용약관
          </button>
          <span className="text-style-body2 text-textColorText3">|</span>
          <button
            type="button"
            onClick={() => navigate('/privacy-policy')}
            className="text-style-body2 text-textColorText2 hover:text-brown-80%-main transition-colors"
          >
            개인정보처리방침
          </button>
        </div>
      </div>
    </div>
  )
}

export default AdminLogin
